import { useCallback, useEffect, useState } from 'react';

export function useMultiKeyPress() {
  const [keysPressed, setPressedKeys] = useState(false);

  const downHandler = useCallback(({ key, ctrlKey, altKey }: KeyboardEvent) => {
    if (ctrlKey && altKey && key === 'd') {
      setPressedKeys(true);
    }
  }, []);

  const upHandler = useCallback(({ key, ctrlKey, altKey }: KeyboardEvent) => {
    if (ctrlKey && altKey && key === 'd') {
      setPressedKeys(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [upHandler, downHandler]);

  return keysPressed;
}
